import {styled} from '@mui/material/styles';
import {DialogContent} from '@mui/material';
import {ForwardedRef, forwardRef, PropsWithChildren} from 'react';

const SDialogContent = styled(DialogContent)(({theme}) => ({
  [theme.breakpoints.down('sm')]: {
    borderTop: 'none',
  },

  padding: theme.spacing(4),
}));

export const DecisionsDialogContent = forwardRef(
  ({children, className}: PropsWithChildren<{className?: string}>, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <SDialogContent className={className} ref={ref}>
        {children}
      </SDialogContent>
    );
  }
);
